/**
 * Picks v2 or v1 of the Upgrade Banners list based on the redesign flag.
 * Same pattern as the other page switches.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import PromoBannersPage   from './PromoBannersPage';
import PromoBannersPageV2 from './PromoBannersPageV2';

export default function PromoBannersPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? PromoBannersPageV2 : PromoBannersPage;
  return <Component {...props} />;
}
